import { OptionList } from 'components/OptionList'
import { SettingKey } from 'config'
import { useEffect, useState } from 'react'
import { getSetting, updateSetting } from 'services'
import { Modal } from 'stories/components'
import { IOptionType } from 'utils/general'

export const OptionModal = ({
  title,
  settingKey,
  onClose,
  childLevel,
}: {
  title: string
  settingKey: string | SettingKey
  onClose: Function
  childLevel?: number
}) => {
  const [isLoading, setLoading] = useState(true)
  const [values, setValues] = useState<IOptionType[]>([])

  useEffect(() => {
    getSetting(settingKey)
      .then((data) => {
        const { value } = data
        if (!value) return

        setValues(JSON.parse(value))
      })
      .finally(() => setLoading(false))
  }, [])

  const onOk = async () => {
    setLoading(true)
    const savingValues = values.filter((value) => value.value !== null)
    await updateSetting(settingKey, JSON.stringify(savingValues))
    setLoading(false)
    onClose(values)
  }

  return (
    <Modal
      title={title}
      onClose={() => onClose(null)}
      titleOkay="Update"
      onOk={onOk}
      loading={isLoading}
      isOpen
      childLevel={childLevel || 0}
    >
      <div className="min-w-[32rem]">
        <OptionList values={values} onChange={setValues} />
      </div>
    </Modal>
  )
}
